import { Injectable } from '@angular/core';
import { EntityScopeEnum } from '@docma-mm-core/entity/entity-scope.enum';
import { Layout } from '@docma-mm-core/layout/layout';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocalLayoutService {

  private localLayout: Layout | null = null;

  constructor(private translate: TranslateService) { }

  public getLocalLayout(): Layout{

    if(!this.localLayout){
      this.localLayout = new Layout();

      const localLayoutId = environment.appContainerConfig.capacitor.localLayoutId;
      
      this.localLayout.Id = +localLayoutId;
      this.localLayout.SUid = crypto.randomUUID();
      this.localLayout.Name = this.translate.instant('MM.layout.localLayoutName');
      this.localLayout.Scope = EntityScopeEnum.Local;
      this.localLayout.IsVisibleForCO = true;
      this.localLayout.IsVisibleForCT = true;
      this.localLayout.IsVisibleForSC = true;
      this.localLayout.HasFilter = false;
      this.localLayout.IsFavoriteAll = false;
      this.localLayout.IsFavoriteUser = true;
    }
    
    return this.localLayout;
  }
}
